import { MoveableBookFeature } from './moveable-book-feature';
import { TextBox } from './text-box';
import { Note } from './note';
import { Color } from './color';

export class TextSelection extends MoveableBookFeature implements Note {

    startBox: TextBox;
    endBox: TextBox;
    textBoxes: Array<TextBox>;
    noteText: string;
    updatedAt: any;
    zIndex = 7;
    color: Color;

    getEndpointName(): string {
        return undefined;
    }
}
